<template>
	<div class="inner-page form-taxonomies">


		<AppHead title="Manage Form Taxonomies" />
		
		<PageHeader 
			title="Manage Form Taxonomies"
			desc="Add and remove taxonomies such as 'Anatomies' and 'Case features'."
			:hasButton="false"
			:showHelper="false"
			:backButton="true"
			:reverseRightBlock="true"
			/>

		<TableTaxonomies 
			:taxonomies="anatomies"
			taxonomyType="Anatomies"
			@addNewTaxonomy="openEditAnatomyModal"
			@editTaxonomy="openEditAnatomyModal"
			/>

		<TableTaxonomies
			:taxonomies="caseFeatures"
			taxonomyType="Case Features"
			@addNewTaxonomy="openEditCaseFeatureModal"
			@editTaxonomy="openEditCaseFeatureModal"
			/>
			

		<Modal 
			v-if="showEditAnatomyModal"
			@close="showEditAnatomyModal = false"
			:title="anatomyToEditId ? `Edit Anatomy` : `New Anatomy`"
			>
			
			<InputText
				label="Name"
				type="text"
				v-model="anatomyForm.name"
				autocomplete="disabled"
				/>

			<InputFancyRadio
				label="Category"
				id="anatomyCategory"
				v-model="anatomyForm.category"
				:options="anatomyCategories"
				/>

			<Button 
				:label="anatomyToEditId ? `Save` : `Add`"
				color="green"
				size="regular"
				icon="plus"
				@click="saveAnatomy"
				/>
		</Modal>

		<Modal 
			v-if="showEditCaseFeatureModal"
			@close="showEditCaseFeatureModal = false"
			:title="caseFeatureToEditId ? `Edit Case Feature` : `New Case Feature`"
			>
			
			<InputText
				label="Name"
				type="text"
				v-model="caseFeatureForm.name"
				autocomplete="disabled"
				/>

			<InputFancyRadio
				label="Category"
				id="caseFeatureCategory"
				v-model="caseFeatureForm.category"
				:options="caseFeatureCategories"
				/>

			<Button 
				:label="caseFeatureToEditId ? `Save` : `Add`"
				color="green"
				size="regular"
				icon="plus"
				@click="saveCaseFeature"
				/>
			
		</Modal>

	</div>
</template>

<script>

import AppLayout from "@/Layouts/AppLayout.vue"
import AppHead from "@/Components/AppHead"
import PageHeader from "@/Components/PageHeader"
import Subtitle from "@/Components/Subtitle"
import Placeholder from "@/Components/Placeholder"
import Button from "@/Components/Button"
import { Link } from '@inertiajs/inertia-vue3'
import InputText from "@/Components/InputText"
import TableTaxonomies from "@/Components/TableTaxonomies"
import Modal from "@/Components/Modal"
import InputFancyRadio from "@/Components/InputFancyRadio"

export default {
	components: {
		AppLayout,
		AppHead,
		PageHeader,
		Subtitle,
		Placeholder,
		Button,
		Link,
		InputText,
		TableTaxonomies,
		Modal,
		InputFancyRadio
	},
	layout: AppLayout,
	props: {
		anatomies: [Object, Array],
		caseFeatures: [Object, Array],
		anatomyCategories: Array,
		caseFeatureCategories: Array
	},
	data: () => {
		return {
			showEditAnatomyModal: false,
			anatomyForm: {
				name: '',
				category: ''
			},
			showEditCaseFeatureModal: false,
			caseFeatureForm: {
				name: '',
				category: ''
			},
			anatomyToEditId: false,
			caseFeatureToEditId: false
		}
	},
	methods: {
		openEditAnatomyModal(id = false){
			if(id){
				this.anatomyToEditId = id
				this.anatomyForm.name = this.anatomies.find(a => a.id == id).name
				this.anatomyForm.category = this.anatomies.find(a => a.id == id).category
			}else{
				this.anatomyToEditId = false
				this.anatomyForm.name = ''
				this.anatomyForm.category = ''
			}
			
			this.showEditAnatomyModal = true
		},
		openEditCaseFeatureModal(id = false){
			if(id){
				this.caseFeatureToEditId = id
				this.caseFeatureForm.name = this.caseFeatures.find(a => a.id == id).name
				this.caseFeatureForm.category = this.caseFeatures.find(a => a.id == id).category
			}else{
				this.caseFeatureToEditId = false
				this.caseFeatureForm.name = ''
				this.caseFeatureForm.category = ''
			}
			
			this.showEditCaseFeatureModal = true
		},
		saveAnatomy(){

			if(this.anatomyForm.name != '' && this.anatomyForm.category != ''){

				if(this.anatomyToEditId){ // Edit

					this.$inertia.post(`/admin/pms-forms/taxonomies/${this.anatomyToEditId}/update`, {
						name: this.anatomyForm.name,
						category: this.anatomyForm.category,
						type: 'anatomy'
					},
					{
	    			onFinish: () => {
							this.showEditAnatomyModal = false
						}
					})
					
				}else{ // Create

					this.$inertia.post('/admin/pms-forms/taxonomies', {
						name: this.anatomyForm.name,
						category: this.anatomyForm.category,
						type: 'anatomy'
					},
					{
						onFinish: () => {
							this.showEditAnatomyModal = false
						}
					})

				}

			}else{
				alert(`Please complete all fields`)
			}
		},
		saveCaseFeature(){
			
			if(this.caseFeatureForm.name != '' && this.caseFeatureForm.category != ''){

				if(this.caseFeatureToEditId){ // Edit

					this.$inertia.post(`/admin/pms-forms/taxonomies/${this.caseFeatureToEditId}/update`, {
						name: this.caseFeatureForm.name,
						category: this.caseFeatureForm.category,
						type: 'case-feature'
					},
					{
	    			onFinish: () => {
							this.showEditCaseFeatureModal = false
						}
					})

				}else{ // Create

					this.$inertia.post('/admin/pms-forms/taxonomies', {
						name: this.caseFeatureForm.name,
						category: this.caseFeatureForm.category,
						type: 'case-feature'
					}, 
					{
						onFinish: () => {
							this.showEditCaseFeatureModal = false
						}
					})
					
				}

			}else{
				alert(`Please complete all fields`)
			}
			
		}
	},
};
</script>

<style lang="sass">

.form-taxonomies

		

</style>